import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { Theme } from '@src/styled-components';
import { Col, Row } from 'antd';
import React from 'react';

interface IMenuComponentItemPropType {
  icon: IconProp;
  title: string;
  tooltipText?: string;
  onClickComponent?: any;
  handleMenuMouseOver: Function;
  activeTooltip: string;
};

interface IMenuComponentItemStateType { };


export default class MenuComponentItem extends React.Component<IMenuComponentItemPropType, IMenuComponentItemStateType> {

  constructor(props: IMenuComponentItemPropType) {
    super(props);
    this.state = {
    };
  }

  handleMouseOver = () => {
    const tooltipText = this.props.tooltipText
    this.props.handleMenuMouseOver(tooltipText)
  }

  render() {
    const {
      activeTooltip,
      title,
      tooltipText,
      icon,
      onClickComponent
    } = this.props;
    return (
      <Wrapper onPointerEnter={this.handleMouseOver}>
        <div onPointerDown={onClickComponent} className="item-container">
          <Row type="flex" align="middle" className={activeTooltip === tooltipText ? 'gray-bg' : ''}>
            <Col className="item-icon-container">
              <FontAwesomeIcon icon={icon} />
            </Col>
            <Col className="item-title">
              <span>{title}</span>
            </Col>
          </Row>
        </div>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  .ant-tooltip-inner {
    min-width: 30px;
    min-height: 32px;
    padding: 6px 8px;
    color: #fff;
    text-align: left;
    text-decoration: none;
    word-wrap: break-word;
    background-color: rgba(255, 0, 0, 0.75);
    border-radius: 4px;
    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }
    .item-container{
        cursor pointer;
        flex: 1;
        height: 42px;
        background-color: ${Theme.standard.white};
        padding: 5px;
        margin-bottom: 10px;
    }

    .item-container-hover:hover{        
        background-color: ${Theme.secondary.supahLightGrey};
        cursor:not-allowed;
    }

    .item-title{        
        padding-left: 12px;
        font-size: 14px;
    }

    .item-icon-container{
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #DEDEDE;
        border-radius: 5px;
        color: #7E7E7E;
        font-size: 16px;
        height: 30px;
        margin-left: 5px;
        padding: 3px;
        width: 30px;
    }

    .gray-bg{
      background-color: #f1f1f1 !important;
    }

    

    
  
`

